import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setLanguage } from './action/preferences';

export const LANGUAGES = [
  { code: 'en', nameKey: 'lang_en', flag: '/images/flag-en.png' },
  { code: 'zh', nameKey: 'lang_zh', flag: '/images/flag-cn.png' },
  { code: 'ms', nameKey: 'lang_ms', flag: '/images/flag-my.png' },
  { code: 'hk', nameKey: 'lang_hk', flag: '/images/flag-hk.png' },
];

const handleDivKeyDown = (onClick) => (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    onClick();
  }
};

const LanguagePopup = ({ opened, onClose, languages = LANGUAGES }) => {
  const { t, i18n } = useTranslation();
  const currentCode = (i18n.language || i18n.resolvedLanguage || '').split('-')[0];

  useEffect(() => {
    if (!opened) return;
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [opened, onClose]);

  const selectLanguage = (code) => {
    if (!code || !['en', 'zh', 'ms', 'hk'].includes(code)) return;
    i18n.changeLanguage(code);
    setLanguage(code);
    onClose();
  };

  if (!opened) return null;

  return (
    <div className="footer-language-popup-overlay" onClick={onClose}>
      <div className="footer-language-popup" onClick={(e) => e.stopPropagation()}>
        <div className="language-popup-content">
          <span className="title">{t('languages')}</span>
          <div className="language-item-container">
            {languages.map((lang) => (
              <div
                key={lang.code}
                data-lang-code={lang.code}
                className={`language-item ${currentCode === lang.code ? 'selected' : ''}`}
                onClick={(e) => selectLanguage(e.currentTarget.dataset.langCode)}
                role="button"
                tabIndex={0}
                onKeyDown={handleDivKeyDown(() => selectLanguage(lang.code))}
              >
                <div className="language-item-image">
                  <img src={lang.flag} alt="" />
                </div>
                <span className="text">{t(lang.nameKey)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguagePopup;
